<template>
   <h1 class="h1 category-title">{{ category.name }}</h1>
</template>

<script>
export default {
    name: "CategoryTitle",
    computed: {
        category() {
            return this.$store.getters["category/getCurrentCategory"];
        },
    }
}
</script>
